/* ===== Reauthentication Modal — confirms identity before sensitive actions ===== */

import { useState } from 'react'
import { Button } from '@/presentation/components/ui/Button'
import { Input } from '@/presentation/components/ui/Input'
import { Modal } from '@/presentation/components/ui/Modal'

interface ReauthModalProps {
  readonly isOpen: boolean
  readonly isVerifying: boolean
  readonly error: string | null
  readonly onCancel: () => void
  readonly onConfirm: (password: string) => void
}

export function ReauthModal({ isOpen, isVerifying, error, onCancel, onConfirm }: ReauthModalProps) {
  const [password, setPassword] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onConfirm(password)
    setPassword('')
  }

  const handleCancel = () => {
    setPassword('')
    onCancel()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleCancel} title="Confirma tu identidad">
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-neutral-600 dark:text-neutral-300">
          Esta es una accion sensible. Ingresa tu contrasena actual para continuar.
        </p>
        <Input
          label="Contrasena"
          type="password"
          required
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="text-xs text-danger-600">{error}</p>}
        <div className="flex justify-end gap-3 pt-4 border-t border-neutral-100 dark:border-neutral-800">
          <Button variant="outline" type="button" onClick={handleCancel} disabled={isVerifying}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={isVerifying || !password}>
            {isVerifying ? 'Verificando...' : 'Confirmar'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
